<template>
  <CommonPages id="services" classs="services-page" titlePrefix="Services - Pixeloogic"
    metaDescription="Connect with premium traffic, AI-powered optimization, and dedicated support. Our global advertising platform helps advertisers and publishers achieve transparent, scalable, and performance-driven results.">

    <div class="services-section service">
      <h2 class="services-section__title">Our Services</h2>
      <p class="services-section__subtitle"> We deliver premium advertising solutions to help advertisers expand reach, optimize campaigns, and achieve measurable results.</p>
      <div class="services-section__cards">
        <div class="service-card service-card--green">
          <div class="service-card-img">
            <img src="@/assets/service-1.svg" alt="Global Premium Ad Network" />
          </div>
          <h3>Global Premium Ad Network</h3>
          <p>Access targeted audiences in 180+ countries with a variety of ad formats, including display, video, and push notifications. Our network guarantees brand-safe placements, broad reach, and performance-driven outcomes.</p>
        </div>
        <div class="service-card service-card--blue">
          <div class="service-card-img">
            <img src="@/assets/service-2.svg" alt="Advanced Analytics & Campaign Optimization" />
          </div>
          <h3>Advanced Analytics & Campaign Optimization</h3>
          <p>Track campaigns in real time with AI-powered bidding, detailed analytics, and anti-fraud protections. Monitor clicks, impressions, and conversions to ensure maximum ROI.</p>
        </div>
        <div class="service-card service-card--red">
          <div class="service-card-img">
            <img src="@/assets/service-3.svg" alt="Tailored Solutions & Expert Support" />
          </div>
          <h3>Tailored Solutions & Expert Support</h3>
          <p>Receive dedicated account management, customized campaign strategies, and seamless API integration. Whether advertiser or publisher, we provide solutions aligned with your goals.</p>
        </div>
      </div>
    </div>

    <div class="partnerships-section">
      <div class="partnerships-section__content">
        <h2 class="partnerships-section__heading">Smart Connections, 
          Real Results</h2>
        <p class="partnerships-section__text">We connect advertisers and publishers through intelligent technology, quality traffic, and hands-on support—delivering growth, transparency, and performance for both sides.</p>
      </div>
      <div class="partnerships-section__images">
        <img src="@/assets/partnership-1.png" alt="Partnership Image 1"
          class="partnerships-section__image--left">
        <img src="@/assets/partnership-2.png" alt="Partnership Image 2"
          class="partnerships-section__image--right">
      </div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/services.scss';

export default {
  name: 'Services',
  components: {
    CommonPages,
  },
};
</script>
